import React from 'react'
import { connect } from 'react-redux';
import * as Actions from '../../common/services/actions';
import CheckBoxFilter from '../../common/components/_CheckboxFilter';
import { toggleSearch } from '../../common/services/selectors';

function SearchAccordianToggle({ search, store, toggle, filter }) { 
    let techArrHid = ['0/403/439', '0/403/408'];
    let chkbxClsName = 'checkbox--item section--menu_item';
    let clsname = 'icon icon-chevron-down';
    let hrefName = '#icon-chevron-down'
    if(toggle){
        chkbxClsName = 'checkbox--item section--menu_item filter-checkbox-open';
        clsname = 'icon icon-chevron-up';
        hrefName = '#icon-chevron-up'
    }
    //let showChecked = search && search.contentCategory && techArrHid.some(v => search.contentCategory.includes(v)) || toggle == true;

    let showAdvanced = () => {
        if(toggle == true){
            toggle = false;
        }
        else{
            toggle = true;
        }
        store.dispatch(Actions.toggleSearch(toggle));
    };
    return (
        <div>
            <div className={chkbxClsName}>
                <input type="checkbox" name="toggle-on" onChange={(e) => showAdvanced()}/>
                <label htmlFor="toggle-on">Overview and guidelines</label>&nbsp;
                <svg xmlns="http://www.w3.org/2000/svg" className={clsname}>
                    <use xlinkHref={hrefName}></use>
                </svg>
                <div className='column large-11 large-push-1' style={{marginBottom: 0.5 + 'rem', marginTop: 0.5 + 'rem'}}>
                    {(filter.taxonomyPathFilters && 
                    filter.taxonomyPathFilters.ContentCategory && toggle) && 
                    techArrHid.map((key) => {
                        let taxItem = filter.taxonomyPathFilters.ContentCategory.children.filter(tax => tax.key == key);
                        return <CheckBoxFilter key={key} search={search} node={taxItem[0]} filter='contentCategory' />
                    })}
                </div>
            </div>     
        </div>
    )
}

const mapStateToProps = state => ({ toggle: toggleSearch(state)});

export default connect(mapStateToProps)(SearchAccordianToggle);